<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style="transform: scale(1.2)">
    <path
        d="M12.31,7h7.38a1.26,1.26,0,0,1,1.23,1.29v2.57a1.25,1.25,0,0,1-1.23,1.28H12.31a1.25,1.25,0,0,1-1.23-1.28V8.29A1.26,1.26,0,0,1,12.31,7Z" />
    <path
        d="M1.23,10.86H8.62a1.25,1.25,0,0,1,1.23,1.28v2.57A1.26,1.26,0,0,1,8.62,16H1.23A1.26,1.26,0,0,1,0,14.71V12.14A1.25,1.25,0,0,1,1.23,10.86Z" />
    <path
        d="M23.38,10.86h7.39A1.25,1.25,0,0,1,32,12.14v2.57A1.26,1.26,0,0,1,30.77,16H23.38a1.26,1.26,0,0,1-1.23-1.29V12.14A1.25,1.25,0,0,1,23.38,10.86Z" />
    <path
        d="M1.23,17.29H8.62a1.25,1.25,0,0,1,1.23,1.28v2.57a1.26,1.26,0,0,1-1.23,1.29H1.23A1.26,1.26,0,0,1,0,21.14V18.57A1.25,1.25,0,0,1,1.23,17.29Z" />
    <path
        d="M23.38,17.29h7.39A1.25,1.25,0,0,1,32,18.57v2.57a1.26,1.26,0,0,1-1.23,1.29H23.38a1.26,1.26,0,0,1-1.23-1.29V18.57A1.25,1.25,0,0,1,23.38,17.29Z" />
    <path
        d="M12.31,19.86h7.38a1.25,1.25,0,0,1,1.23,1.28v2.57A1.26,1.26,0,0,1,19.69,25H12.31a1.26,1.26,0,0,1-1.23-1.29V21.14A1.25,1.25,0,0,1,12.31,19.86Z" />
</svg>
